import { sendWebsocketMessage } from "../../../../../../App";

export const retrieveUserTemplates = () => {
    const msg = {
        messageType: 'existingExports',
    };
    sendWebsocketMessage(msg);

};
